<app-modal #modalRef [active]="active" [width]="1100" (modalClosed)="onModalClosed()">
  <div class="p-3">
    <div class="columns">
      <div class="column">
        <!-- STEP 1 -->
        <form *ngIf="grundakteForm && step === 1" [formGroup]="grundakteForm">
          <div class="title is-4 has-text-centered is-bold color-darkblue">
            Grundakteneinsicht
            <p class="has-text-grey is-size-6">Bestellen Sie Ihre Grundakteneinsicht in wenigen Schritten</p>
          </div>
          <div class="title is-5 has-text-left is-darkblue">
            Bitte wählen Sie die benötigten Produkte. Der Vor-Ort-Service ist bereits inklusive. <i class="fa fa-info-circle" [matTooltip]="'Wenn die Behörde einen Vor-Ort-Termin zulässt, beauftragen wir unsere Agenten zur Beschleunigung des Vorgangs.'"></i>
          </div>

          <div class="product-list" [formGroup]="grundakteForm.get('grundakteSelections')">
            <div class="product-entry" *ngFor="let product of sortedGrundakteProducts(); index as i">
              <div class="card product-card"
                   [ngClass]="{'selected': isProductSelected(product.nameShort)}">
                <div class="card-content">
                  <div class="is-flex is-align-items-center is-justify-content-space-between">
                    <label class="is-flex is-align-items-center"
                           [for]="'grundakte_checkbox_' + i">
                      <input id="grundakte_checkbox_{{i}}"
                             type="checkbox"
                             class="custom-checkbox"
                             [formControlName]="product.nameShort">
                      <span class="ml-2 is-bold has-text-grey-dark"
                            [ngClass]="{'required': isProductSelectionInvalid}">
                        {{ product.name_long }}
                      </span>
                    </label>
                    <span class="price-tag"
                          *ngIf="isTeilungserklaerung(product.nameShort)">
                      {{ teilungPrice }} € netto
                    </span>
                    <span class="price-tag" *ngIf="isBewilligungsurkunde(product.nameShort)">
                      {{ fixedBewilPrice }} €
                      <ng-container *ngIf="bewilCertificatePrice > 0">
                        + {{ bewilCertificatePrice }} €/Urkunde
                      </ng-container>
                      netto
                    </span>
                  </div>

                  <div class="mt-4"
                       *ngIf="isProductSelected(product.nameShort) && isBewilligungsurkunde(product.nameShort)"
                       [formGroup]="grundakteForm.get('bewilSubclasses')">

                    <div class="columns is-multiline mt-1">
                      <div class="column is-half" *ngFor="let sub of bewilSubClasses">
                        <label class="is-flex is-align-items-center" [for]="'bewil_sub_' + sub.className">
                          <input type="checkbox" class="custom-checkbox" [id]="'bewil_sub_' + sub.className" [formControlName]="sub.className"/>

                          <span class="ml-2 is-bold has-text-grey-dark"
                                [ngClass]="{ 'required': showInvalidInputs && hasBewilSelectionError() }">
                            {{ sub.name }}
                          </span>

                          <ng-container *ngIf="sub.className === 'BEWUNR'">
                            <span class="ml-2" matTooltip="Wählen Sie gezielt die benötigten Urkunden aus.">
                              <fa-icon [icon]="faInfoCircle"></fa-icon>
                            </span>
                          </ng-container>

                        </label>
                      </div>
                    </div>

                    <p class="error-text" *ngIf="showInvalidInputs && hasBewilSelectionError()">
                      Bitte wählen Sie mindestens eine Bewilligungsart aus.
                    </p>

                    <div class="mt-4"
                         *ngIf="shouldDisplayLfdCertificates() && certificateForm"
                         [formGroup]="certificateForm">
                      <div formArrayName="lfdCertificates">
                        <p class="is-bold is-size-6 mb-2"
                           [ngClass]="{'required': showInvalidInputs && hasCertificateError()}">
                          Wählen Sie gezielt die benötigten Urkunden aus.
                        </p>

                        <div class="certificate-row mb-3"
                             *ngFor="let certificateGroup of lfdCertificates.controls; let idx = index"
                             [formGroupName]="idx">
                          <div class="certificate-row-grid">
                            <div class="certificate-field">
                              <label class="is-size-7 has-text-grey">Grundbuchblatt</label>
                              <input type="text" class="border-input is-rounded" formControlName="landRegisterPage">
                            </div>
                            <div class="certificate-field">
                              <label class="is-size-7 has-text-grey">Abt.</label>
                              <div class="select is-rounded w-100 custom-select">
                                <select formControlName="department">
                                  <option disabled value="">-</option>
                                  <option value="2">Abt. II</option>
                                  <option value="3">Abt. III</option>
                                </select>
                              </div>
                            </div>
                            <div class="certificate-field">
                              <label class="is-size-7 has-text-grey">Lfd. Nr.</label>
                              <input type="number" min="0" step="1" (input)="onIntegerInput($event)"
                                     class="border-input is-rounded" formControlName="serialNumber">
                            </div>
                            <div class="certificate-field">
                              <label class="is-size-7 has-text-grey">Urkunde/Recht</label>
                              <input type="text" class="border-input is-rounded" formControlName="certificate">
                            </div>
                            <div class="certificate-remove" *ngIf="lfdCertificates.length > 1">
                              <button type="button" class="delete-icon-button mb-4" aria-label="Eintrag entfernen" (click)="removeCertificateEntry(idx)">
                                ×
                              </button>
                            </div>
                          </div>
                        </div>

                        <button type="button"
                                class="button is-small is-outlined is-rounded"
                                (click)="addCertificateEntry()">
                          + Weitere Urkunde hinzufügen
                        </button>

                        <p class="error-text mt-2" *ngIf="showInvalidInputs && hasCertificateError()">
                          Bitte füllen Sie alle Angaben zu den ausgewählten Urkunden aus.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div *ngIf="isConnectOrigin" class="notification is-info is-light mt-4">
            <p class="is-size-6 has-text-weight-bold">Wichtiger Hinweis:</p>
            <p class="is-size-6">
              Zum Nachweis des berechtigten Interesses fordern die Behörden einen aktuellen Grundbuchauszug, welchen wir
              zur Vorlage beim Amt kostenlos (gegen Behördengebühr) organisieren.
            </p>
          </div>
        </form>

        <!-- STEP 2 -->
        <div *ngIf="step === 2">
          <div class="title is-4 has-text-centered is-bold color-darkblue">
            Grundakteneinsicht
          </div>

          <div class="notification is-info is-light">
            <p class="is-size-6 has-text-weight-bold">Wichtiger Hinweis:</p>
            <p class="is-size-6">
              Zum Nachweis des berechtigten Interesses fordern die Behörden einen aktuellen Grundbuchauszug, welchen wir
              zur Vorlage beim Amt kostenlos (gegen Behördengebühr) organisieren.
            </p>
          </div>

          <ng-container>
            <p class="is-bold is-size-6 mt-4">Grundbuchblatt-Nr.</p>
            <app-folio-number [property]="selectedProperty"
                              [displayAdditionalCostInformation]="true"></app-folio-number>

            <p class="is-bold is-size-6 mt-4">Eigentümerdaten</p>
            <app-object-owner [property]="selectedProperty"></app-object-owner>
          </ng-container>
        </div>
      </div>
    </div>

    <!-- FOOTER -->
    <div class="columns" *ngIf="step === 1">
      <div class="column is-one-third">
        <a (click)="hasGrundakteDocument() ? removeGrundakteDocument() : null"
           class="button back-button is-size-6 has-round-border mb-1"
           [ngClass]="{'disabled': !hasGrundakteDocument()}"
           style="border:none;">
          <div class="columns" style="align-items: center;justify-content: center">
            <img src="assets/images/orders-icons/trash-can.svg" alt="Trashcan">
          </div>
        </a>
      </div>
      <div class="column is-one-third"></div>
      <div class="column is-one-third">
        <a (click)="isAllowedToOrder ? onSubmit() : $event.stopPropagation()" type="submit"
           class="button buy-button is-size-6 has-round-border mb-1" style="border:none; display: block!important;">
          <div class="columns" style="align-items: center;justify-content: center;padding-top: 5px">
            <div class="column is-bold"><p style="padding-left: 2rem; padding-bottom: 10px;">Weiter</p></div>
            <div class="column is-one-fifth" style="padding-left: 0">
              <img alt="Arrow Right" src="assets/images/button/right_btn.svg">
            </div>
          </div>
        </a>
      </div>
    </div>

    <div class="columns" *ngIf="step === 2">
      <div class="column is-one-third">
        <a (click)="backToStepOne()" class="button back-button is-size-6 has-round-border mb-1" style="border:none;">
          <div class="columns" style="align-items: center;justify-content: center">
            <img alt="Arrow Left" src="assets/images/button/left_btn.svg">
          </div>
        </a>
      </div>
      <div class="column is-one-third"></div>
      <div class="column is-one-third">
        <a (click)="isAllowedToOrder ? onConfirmGrunde() : $event.stopPropagation()"
           class="button buy-button is-size-6 has-round-border mb-1" style="border:none; display: block!important;">
          <div class="columns" style="align-items: center;justify-content: center;padding-top: 5px">
            <div class="column is-bold"><p style="padding-left: 2rem; padding-bottom: 10px;">Weiter</p></div>
            <div class="column is-one-fifth" style="padding-left: 0">
              <img alt="Arrow Right" src="assets/images/button/right_btn.svg">
            </div>
          </div>
        </a>
      </div>
    </div>

    <div class="columns">
      <div class="column has-text-centered is-size-7 has-text-grey">
        {{ 'Schritt ' + (hasGrundeStep ? step : 1) + ' / ' + (hasGrundeStep ? 2 : 1) }}
      </div>
    </div>
  </div>
</app-modal>
